/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | fedex_ground | FedEx Ground®|
 * | fedex_home_delivery | FedEx Home Delivery®|
 * | fedex_ground_economy | FedEx Ground® Economy|
 * | fedex_2_day | FedEx 2Day®|
 * | fedex_2_day_am | FedEx 2Day® A.M.|
 * | fedex_express_saver | FedEx Express Saver®|
 * | fedex_standard_overnight | FedEx Standard Overnight®|
 * | fedex_priority_overnight | FedEx Priority Overnight®|
 * | fedex_first_overnight | FedEx First Overnight®|
 * | fedex_international_economy | FedEx International Economy®|
 * | fedex_international_priority | FedEx International Priority®|
 * | fedex_international_first | FedEx International First®|
 * | fedex_europe_first_international_priority | FedEx International First®|
 * | fedex_international_connect_plus | FedEx International Connect Plus|
 * | fedex_first | FedEx First |
 * | fedex_priority | FedEx Priority |
 * | fedex_priority_express | FedEx Priority Express|
 * | fedex_economy_select | FedEx® Economy |
 * | fedex_regional_economy | FedEx® Regional Economy |
 * | fedex_first_overnight_extra_hours | First Overnight® EH |
 * | fedex_international_priority_express | International Priority® Express |
 * | fedex_next_day_mid_morning | Next Day Mid Morning |
 * | fedex_priority_overnight_extra_hours | Priority Overnight® EH |
 * | fedex_standard_overnight_extra_hours | Standard Overnight® EH |
 */
export const ServiceLevelFedExEnum = {
  FedexGround: "fedex_ground",
  FedexHomeDelivery: "fedex_home_delivery",
  FedexSmartPost: "fedex_smart_post",
  FedexGroundEconomy: "fedex_ground_economy",
  Fedex2Day: "fedex_2_day",
  Fedex2DayAm: "fedex_2_day_am",
  FedexExpressSaver: "fedex_express_saver",
  FedexStandardOvernight: "fedex_standard_overnight",
  FedexPriorityOvernight: "fedex_priority_overnight",
  FedexFirstOvernight: "fedex_first_overnight",
  FedexInternationalEconomy: "fedex_international_economy",
  FedexInternationalPriority: "fedex_international_priority",
  FedexInternationalFirst: "fedex_international_first",
  FedexEuropeFirstInternationalPriority:
    "fedex_europe_first_international_priority",
  FedexInternationalConnectPlus: "fedex_international_connect_plus",
  FedexFirst: "fedex_first",
  FedexPriority: "fedex_priority",
  FedexPriorityExpress: "fedex_priority_express",
  FedexEconomySelect: "fedex_economy_select",
  FedexRegionalEconomy: "fedex_regional_economy",
  FedexFirstOvernightExtraHours: "fedex_first_overnight_extra_hours",
  FedexInternationalPriorityExpress: "fedex_international_priority_express",
  FedexNextDayMidMorning: "fedex_next_day_mid_morning",
  FedexPriorityOvernightExtraHours: "fedex_priority_overnight_extra_hours",
  FedexStandardOvernightExtraHours: "fedex_standard_overnight_extra_hours",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | fedex_ground | FedEx Ground®|
 * | fedex_home_delivery | FedEx Home Delivery®|
 * | fedex_ground_economy | FedEx Ground® Economy|
 * | fedex_2_day | FedEx 2Day®|
 * | fedex_2_day_am | FedEx 2Day® A.M.|
 * | fedex_express_saver | FedEx Express Saver®|
 * | fedex_standard_overnight | FedEx Standard Overnight®|
 * | fedex_priority_overnight | FedEx Priority Overnight®|
 * | fedex_first_overnight | FedEx First Overnight®|
 * | fedex_international_economy | FedEx International Economy®|
 * | fedex_international_priority | FedEx International Priority®|
 * | fedex_international_first | FedEx International First®|
 * | fedex_europe_first_international_priority | FedEx International First®|
 * | fedex_international_connect_plus | FedEx International Connect Plus|
 * | fedex_first | FedEx First |
 * | fedex_priority | FedEx Priority |
 * | fedex_priority_express | FedEx Priority Express|
 * | fedex_economy_select | FedEx® Economy |
 * | fedex_regional_economy | FedEx® Regional Economy |
 * | fedex_first_overnight_extra_hours | First Overnight® EH |
 * | fedex_international_priority_express | International Priority® Express |
 * | fedex_next_day_mid_morning | Next Day Mid Morning |
 * | fedex_priority_overnight_extra_hours | Priority Overnight® EH |
 * | fedex_standard_overnight_extra_hours | Standard Overnight® EH |
 */
export type ServiceLevelFedExEnum = ClosedEnum<typeof ServiceLevelFedExEnum>;

/** @internal */
export const ServiceLevelFedExEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelFedExEnum
> = z.nativeEnum(ServiceLevelFedExEnum);

/** @internal */
export const ServiceLevelFedExEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelFedExEnum
> = ServiceLevelFedExEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelFedExEnum$ {
  /** @deprecated use `ServiceLevelFedExEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelFedExEnum$inboundSchema;
  /** @deprecated use `ServiceLevelFedExEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelFedExEnum$outboundSchema;
}
